import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Select from "react-select";

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';
import WAFRestrictionBanner from './WAFRestrictionBanner';

import './Ship.css'

import ShipDetailModal from './Modal/ShipDetailModal'
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";
import { fetchShipments, isPersonalInfoRestricted } from '../../../utils/apiClient';

const Ship = () => {
  const { t } = useTranslation();

  const [shipList, setShipList] = React.useState([])
  const [shipInfo, setShipInfo] = useState({})
  const [isRestricted, setIsRestricted] = useState(false) // WAF制限状態
  const [restrictionMeta, setRestrictionMeta] = useState(null) // 制限メタデータ

  const options = [
    {value: 1, label: t('ship.status1')},
    {value: 2, label: t('ship.status2')},
    {value: 3, label: t('ship.status3')},
    {value: 4, label: t('ship.status4')},
    {value: 5, label: t('ship.status5')},
    {value: 6, label: t('ship.status6')},
    {value: 7, label: t('ship.status7')}
  ];
  const [status, setStatus] = useState([options[0], options[1]]);
  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [orderStartDate, setOrderStartDate] = useState('');
  const [orderEndDate, setOrderEndDate] = useState('');
  const [startShipmentId, setStartShipmentId] = useState('');
  const [endShipmentId, setEndShipmentId] = useState('');
  const [cardName, setCardName] = useState('');
  const [note, setNote] = useState('');

  const csvOptions = [
    {value: 1, label: t('ship.how1')},
    {value: 2, label: t('ship.how2')},
    {value: 3, label: t('ship.how3')},
  ];

  const [csv, setCSV] = useState([]);
  const [reload, setReload] = useState(false)

  useEffect(() => {
    setReload(false)

    if (currentStatus == shipInfo.status) return;

    let params = new URLSearchParams();
    status.forEach((s, i) => {
      params.append('status[' + i + ']', s.value)
    })
    params.append('name', name);
    params.append('date', date);
    params.append('card_name', cardName);
    params.append('note', note);
    params.append('order_start_date', orderStartDate);
    params.append('order_end_date', orderEndDate);
    params.append('start_shipment_id', startShipmentId);
    params.append('end_shipment_id', endShipmentId);
    
    if (csv.some((c) => c.value == 1))
      params.append('is_csv_output_clickpost', true);
    if (csv.some((c) => c.value == 2))
      params.append('is_csv_output_yupack', true);
    if (csv.some((c) => c.value == 3))
      params.append('is_csv_output_yupacket', true);

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    const api = async () => {
      try {
        const response = await fetchShipments(params.toString());
        const responseData = await response.json();
        
        // 新しいレスポンス形式に対応
        if (responseData.data) {
          // 新しい形式（data + meta構造）
          setShipList(responseData.data);
          setIsRestricted(responseData.meta?.personal_info_restricted || false);
          setRestrictionMeta(responseData.meta || null);
          
          // WAF制限状態のメッセージ表示
          if (responseData.meta?.personal_info_restricted) {
            console.log('個人情報が制限されています（WAFブロック対応）:', responseData.meta?.message);
          }
        } else {
          // 従来の形式（後方互換性）
          setShipList(responseData);
          setIsRestricted(false);
          setRestrictionMeta(null);
        }
        
      } catch (error) {
        console.error('配送情報の取得に失敗しました:', error);
        // エラー時も制限状態をリセット
        setIsRestricted(false);
        setRestrictionMeta(null);
        alert(t('common.error'));
      }
    }

    const timer = setTimeout(() => {
      api();
    }, 500)
  
  }, [status, name, cardName, startShipmentId, endShipmentId, orderStartDate, orderEndDate, note, shipInfo.status, csv, reload])

  const [selectedValues, setSelectedValues] = React.useState([]);
  const [checkboxStates, setCheckboxStates] = React.useState({});

  const handleCheckboxClick = (shipId,checked) => {
    setSelectedValues(prevValues => {
      if (checked) {
        return [...prevValues, shipId];
      } else {
        return prevValues.filter(v => v !== shipId);
      }
    });
    setCheckboxStates(prevStates => ({
      ...prevStates,
      [shipId]: checked
    }));
  };

  const handleSubmit = () => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    const selectedParams = selectedValues.map(value => `${value}`).join(',');
    if (selectedParams == '') {
      alert(t('ship.error'))
      return
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/ship/download/`+selectedParams, {
    method: 'GET',
    headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Authorization': 'Bearer '+ decodeURIComponent(token),
        'Content-Type': 'application/json'
    },
    credentials: 'include',
    })
    .then(res => {
        if (!res.ok) { // If the response is not ok, throw an error
            throw new Error(t('common.error'));
        }
        return res.blob();
    })
    .then(blob => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    // 今日の日付を取得
    const dt = new Date();
    link.setAttribute('download', 'OripalShipments_' + dt.getFullYear() + (dt.getMonth() + 1) + dt.getDate() + '.zip');
    document.body.appendChild(link);
    link.click();

    // Clean up after the download
    setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }, 100);

    setReload(true)
    })
    .catch(error => {
        alert(t('common.error'))
    });
  };

  const handlePackSubmit = (type) => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    const selectedParams = selectedValues.map(value => `${value}`).join(',');
    if (selectedParams == '') {
      alert(t('ship.error'))
      return
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/ship/download/`+selectedParams + '/' + type, {
    method: 'GET',
    headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Authorization': 'Bearer '+ decodeURIComponent(token),
        'Content-Type': 'application/json'
    },
    credentials: 'include',
    })
    .then(res => {
        if (!res.ok) { // If the response is not ok, throw an error
            throw new Error(t('common.error'));
        }
        return res.blob();
    })
    .then(blob => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    // 今日の日付を取得
    const dt = new Date();
    if (type == 'clickpost')
      link.setAttribute('download', 'click_post_' + dt.getFullYear() + (dt.getMonth() + 1) + dt.getDate() + '.csv');
    else if (type == 'yupack')
      link.setAttribute('download', 'yupack_' + dt.getFullYear() + (dt.getMonth() + 1) + dt.getDate() + '.csv');
    else if (type == 'yupacket')
      link.setAttribute('download', 'yupacket_' + dt.getFullYear() + (dt.getMonth() + 1) + dt.getDate() + '.csv');
    else if (type == 'pack')
      link.setAttribute('download', t('ship.pack2') + dt.getFullYear() + (dt.getMonth() + 1) + dt.getDate() + '.csv');
    else if (type == 'pick')
      link.setAttribute('download', t('ship.pick2') + dt.getFullYear() + (dt.getMonth() + 1) + dt.getDate() + '.csv');
    else if (type == 'locations')
      link.setAttribute('download', t('ship.locations') + '_' + dt.getFullYear() + (dt.getMonth() + 1) + dt.getDate() + '.zip');
    document.body.appendChild(link);
    link.click();

    // Clean up after the download
    setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }, 100);

    setReload(true)
    })
    .catch(error => {
        alert(t('common.error'))
    });
  };

  const CreateShipmentList = () => {
    return shipList.map((ship) => {
      return (
        <Tr ship={ship} onValueChange={handleCheckboxClick} checkboxStates={checkboxStates} statusChangeHandler={statusChangeHandler} isRestricted={isRestricted} key={"ship" + ship.id}/>
      )
    })
  }

  const [statusChangeModalIsOpen, setStatusChangeModalIsOpen] = useState(false)

  const [currentStatus, setCurrentStatus] = useState(0)

  const statusChangeHandler = (id, status) => {
    setCurrentStatus(status)
    const shipDetail = shipList.find(ship => ship.id == id)
    setShipInfo(shipDetail)
    setStatusChangeModalIsOpen(true)
  }

  const allCheckHandler = (e) => {
    e.preventDefault();

    const checked = e.target.checked;
    const newCheckboxStates = {};
    shipList.forEach(ship => {
      newCheckboxStates[ship.id] = checked;
    });
    setCheckboxStates(newCheckboxStates);
    setSelectedValues(checked ? shipList.map(ship => ship.id) : []);
  }

  const packCsvUploadHandler = (e) => {
    e.preventDefault();

    if (window.confirm(t('ship.confirm'))) {
      let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
      if (xsrfToken) {
          xsrfToken = xsrfToken.split('=')[1]
      }
      let token = document.cookie.split('; ').find(row => row.startsWith('token'));
      if (token) {
          token = token.split('=')[1]
      }

      
      const body = new FormData();
      body.append('file', document.getElementById('packCsvUpload').files[0]);

      fetch(`${process.env.REACT_APP_API_URL}/api/ship/upload`, {
        method: 'POST',
        cache: 'no-store',
        headers: {
          'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
          'Authorization': 'Bearer '+ decodeURIComponent(token),
        },
        credentials: 'include',
        body: body,
      })
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (data.errors) {
          alert(Object.values(data.errors)[0]);
          return
        } else {
          alert(data.message)
        }
        e.target.value = ''
        setReload(true)
      })
      .catch(error => {
        alert(t('common.error'))
        e.target.value = ''
      });
    } else {
      e.target.value = ''
      return
    }
  }

  const shipDirectHandler = (e) => {
    e.preventDefault();

    if (selectedValues.length == 0) {
      alert(t('ship.error'))
      return
    }

    localStorage.setItem('shipIds', selectedValues)
    
    let shopPath = window.location.href.split('/')[3]
    window.open(`/${shopPath}/ship/direction`, '_blank')
  }

  Modal.setAppElement('#root');

  return (
    <>
      <Header />
      <SideMenu />
      <div className="ship">
        <div className="ship-title">{t('ship.title')}</div>
        <div className='clearfix'></div>
        
        {/* WAF制限状態のバナー表示 */}
        {isRestricted && restrictionMeta && (
          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium">
                  {restrictionMeta.message}
                </p>
                <p className="text-xs text-yellow-600 mt-1">
                  理由: {restrictionMeta.restriction_reason}
                </p>
                {restrictionMeta.available_fields && (
                  <p className="text-xs text-yellow-600 mt-1">
                    利用可能な項目: {restrictionMeta.available_fields.join(', ')}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
        
        <div className="ship-search">
          <table className="ship-search-table">
            <tbody>
              <tr>
                <th>
                  <label className="ship-search-label">{t('ship.status')}</label>
                </th>
              </tr>
              <tr>
                <td>
                  <Select
                    className="ship-search-select"
                    classNamePrefix="ship-search-select"
                    options={options}
                    defaultValue={status}
                    onChange={(e) => setStatus(e)}
                    isMulti
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="ship-search-table-display" style={{display: 'none'}}>
            <table className="ship-search-table">
              <tbody>
                <tr>
                  <th>
                    <label className="ship-search-label">{t('ship.client')}</label>
                  </th>
                </tr>
                <tr>
                  <td>
                    <input className="ship-search-input" type="text" placeholder={t('ship.name')} value={name} onChange={(e) => setName(e.target.value)}/>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label className="ship-search-label">{t('ship.card_name')}</label>
                  </th>
                  <th>
                    <label className="ship-search-label">{t('ship.remark')}</label>
                  </th>
                </tr>
                <tr>
                  <td>
                    <input className="ship-search-input" type="text" placeholder={t('ship.card_name')} value={cardName} onChange={(e) => setCardName(e.target.value)}/>
                  </td>
                  <td>
                    <input className="ship-search-input" type="text" placeholder={t('ship.remark')} value={note} onChange={(e) => setNote(e.target.value)}/>
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="ship-search-table">
                <tr>
                  <th>
                    <label className="ship-search-label">{t('ship.day')}</label>
                  </th>
                </tr>
                <tr>
                  <td>
                    <input className="ship-search-input" type="date" value={orderStartDate} style={{width: '47%'}} onChange={(e) => setOrderStartDate(e.target.value)}/>〜
                    <input className="ship-search-input" type="date" value={orderEndDate} style={{width: '47%'}} onChange={(e) => setOrderEndDate(e.target.value)}/>
                  </td>
                </tr>
            </table>
            <table className="ship-search-table">
                <tr>
                  <th>
                    <label className="ship-search-label">{t('ship.id')}</label>
                  </th>
                </tr>
                <tr>
                  <td>
                    <input className="ship-search-input" type="text" value={startShipmentId} style={{width: '47%'}} onChange={(e) => setStartShipmentId(e.target.value)}/>〜
                    <input className="ship-search-input" type="text" value={endShipmentId} style={{width: '47%'}} onChange={(e) => setEndShipmentId(e.target.value)}/>
                  </td>
                </tr>
            </table>
            <table className="ship-search-table">
              <tbody>
                <tr>
                  <th>
                    <label className="ship-search-label">{t('ship.csv1')}</label>
                  </th>
                </tr>
                <tr>
                  <td>
                    <Select
                      className="ship-search-select"
                      classNamePrefix="ship-search-select"
                      options={csvOptions}
                      defaultValue={csv}
                      onChange={(e) => setCSV(e)}
                      isMulti
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="ship-search-table-hidden">
            <button className="ship-search-table-display-button" style={{width: '14rem'}} onClick={
              (e) => {
                if (document.getElementsByClassName('ship-search-table-display')[0].style.display == 'none') {
                  document.getElementsByClassName('ship-search-table-display')[0].style.display = 'block'
                  document.getElementsByClassName('ship-search-table-hidden')[0].style.display = 'none'
                } else {
                  document.getElementsByClassName('ship-search-table-display')[0].style.display = 'none'
                }
              }
            }>{t('ship.display1')}</button>
          </div>
          <table className="ship-search-table" style={{width: '80%'}}>
            <tbody>
            <tr>
                <th>
                  <label className="ship-search-label">{t('ship.csv2')}</label>
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th>
                  <label className="ship-search-label">{t('ship.csv3')}</label>
                </th>
                <th>
                  <label className="ship-search-label">{t('ship.order')}</label>
                </th>
              </tr>
              <tr>
                <td>
                  <button className="ship-search-button" onClick={(e) => {handlePackSubmit('pick')}}>{t('ship.pick1')}</button>
                </td>
                <td>
                  <button className="ship-search-button" onClick={(e) => {handlePackSubmit('pack')}}>{t('ship.pack1')}</button>
                </td>
                <td>
                  <button className="ship-search-button" onClick={handleSubmit}>{t('ship.summary')}</button>
                </td>
                <td>
                  <button className="ship-search-button" onClick={(e) => {handlePackSubmit('locations')}}>{t('ship.locations')}</button>
                </td>
                <td>
                  <button className="ship-search-button" onClick={(e) => {document.getElementById('packCsvUpload').click()}}>{t('ship.checked')}</button>
                  <input type="file" name="file" accept=".csv" id="packCsvUpload" style={{display: 'none'}} onChange={(e) => {packCsvUploadHandler(e)}}/>
                </td>
                <td>
                  <button className="ship-search-button" onClick={shipDirectHandler} >{t('ship.display2')}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        {/* 個人情報制限の警告バナー */}
        {isRestricted && (
          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4 mx-4">
            <div className="flex">
              <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <div className="ml-3">
                <p><strong>アクセス制限中:</strong> {restrictionMeta?.message || '個人情報の表示が制限されています'}</p>
                <p className="text-xs mt-1">個人名情報は「***」で表示されます。</p>
              </div>
            </div>
          </div>
        )}
        
        <div className="ship-content">
          <div className="ship-content-table">
            <table className="ship-content-table">
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" onClick={allCheckHandler} />
                  </th>
                  <th>{t('ship.id')}</th>
                  <th>{t('ship.day')}</th>
                  <th>{t('ship.user_id')}</th>
                  <th>{t('ship.client')}</th>
                  <th>{t('ship.country')}</th>
                  <th>{t('ship.city')}</th>
                  <th>{t('ship.prefecture')}</th>
                  <th>{t('ship.ship')}</th>
                  <th>{t('ship.postal_code')}</th>
                  <th>{t('ship.rank')}</th>
                  <th>{t('ship.status')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <CreateShipmentList />
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ShipDetailModal statusChangeModalIsOpen={statusChangeModalIsOpen} setStatusChangeModalIsOpen={setStatusChangeModalIsOpen} shipInfo={shipInfo} setShipInfo={setShipInfo}/>
    </>
  )
}

export default Ship